/* @flow */
import React, { useContext } from "react";
import DetailsHeaderWrapper, {
  DetailsHeaderOffscreenOverscroll,
} from "nexia_mobile/components/Details/DetailsHeaders/DetailsHeaderWrapper";
import Location from "nexia_mobile/models/location";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  model: Location,
};

const BuildingHeader = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.details.BuildingHeader;
  const name = props.model.get("name");
  return (
    <div data-component-name="BuildingHeader">
      <DetailsHeaderOffscreenOverscroll />
      <DetailsHeaderWrapper>
        <div className="details-status-description">
          {`${language.buildingConfiguration} > `}
          {name}
        </div>
      </DetailsHeaderWrapper>
    </div>
  );
};

export default BuildingHeader;



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/BuildingHeader.jsx